module.exports = __webpack_public_path__ + "img/about_02.087ba340.png";